module.exports = __webpack_public_path__ + "img/settingsIcon.d72000a3.svg";